import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=7f3bc5cf&scoped=true&"
import script from "./ProductVariants.vue?vue&type=script&lang=js&"
export * from "./ProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&id=7f3bc5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3bc5cf",
  null
  
)

export default component.exports